export const ppAppStorageVersion = '2.5.0';

export enum StorageKey {
  storageVersion = 'ppApp.storageVersion',
  loggedInRedirect = 'ppApp.loggedInRedirect',
}
